<script setup lang="ts">
import { MeasureResult } from '@Shared/utils/types';
import { MetricType } from './utility';
import ProgramBreakdown from './parts/ProgramBreakdown.vue';

const props = defineProps<{
  title: string;
  count: number;
  details: {
    title: string;
    count: number;
    metricType: MetricType;
    metricValue: MeasureResult;
    metricPercentages: {
      negative: number;
      neutral: number;
      positive: number;
      negativeCount: number;
      neutralCount: number;
      positiveCount: number;
    };
  }[];
}>();
</script>
<template>
  <div>
    <div class="flex flex-col justify-between mt-6 xl:ml-6 font-family[Roboto] color-[#4F4F4F] xs:ml-0">
      <div class="xl:text-4 font-500 xs:text-5">
        {{ title }}
      </div>
      <div class="xl:mb-6 ml-4 flex justify-between flex-col xs:ml-0">
        <ProgramBreakdown
          v-for="(program, index) in props.details"
          :key="program.title"
          :program="program"
          show-gauge
          :class="{ 'border-b-2': index != props.details.length - 1 }"
        />
      </div>
    </div>
  </div>
</template>
